module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "transition-expand-height",
      "mode": "out-in"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "before-leave": _vm.beforeLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0151f966"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/transitions/ExpandHeight.vue
// module id = 98
// module chunks = 3